import React from 'react';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';
import { RESIDENTIAL_STATUS_OTHER_DATA } from '../utils/personaDetailsUtils';

const ResidentialStatusOther = () => (
  <Content>
    {({ accountDetailsFormErrorSelect = '' }) => (
      <Field name="residentialStatusOther" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="residentialStatusOther"
            validationMessage={touched && !!error ? accountDetailsFormErrorSelect : ''}
          >
            <Field name="residentialStatusOther" validate={isRequired} component="select">
              {({ input }) => (
                <GenericSelect
                  name="titleOther"
                  {...input}
                  items={RESIDENTIAL_STATUS_OTHER_DATA}
                  selectedId={!input.value ? null : input.value}
                  onChange={selectedId => {
                    input.onChange(selectedId);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default ResidentialStatusOther;
